import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';
import upkeep from '../../assets/images/projects/upkeep.png';
import emailValidify from '../../assets/images/projects/email-validify.png';
import jasonsWineApp from '../../assets/images/projects/jasonsliquor.jpg';
import mimsha from '../../assets/images/projects/mimsha.png';

const projects = [
  {
    title: 'UpKeep',
    type: 'CMMS App',
    description: 'A Mobile-first, AI Powered CMMS',
    technologies: ['Android', 'Kotlin', 'Coroutines', 'Jetpack', 'Firebase', 'Google APIs'],
    image: upkeep,
    iconPadding: false,
    projectUrl: 'https://upkeep.com'
  },
  {
    title: 'EmailValidify',
    type: 'Web Platform',
    description: 'Real-time email verification platform',
    technologies: ['React', 'Java', 'Spring Boot', 'PHP', 'MySQL', 'WebSockets'],
    image: emailValidify,
    iconPadding: true,
    projectUrl: 'https://emailvalidify.com'
  },
  {
    title: "Jason's Wine App",
    type: 'Mobile App',
    description: 'On-Demand Liquor Delivery App',
    technologies: ['React Native', 'Google Maps API', 'Firebase', 'Stripe SDK'],
    image: jasonsWineApp,
    iconPadding: false,
    projectUrl: 'https://jasonsliquor.com'
  },
  {
    title: 'Mimsha',
    type: 'P2P Platform',
    description: 'P2P delivery platform with KYC, chat & payments',
    technologies: ['React Native', 'Jumio SDK', 'Stripe Payment', 'Firebase', 'Google APIs'],
    image: mimsha,
    iconPadding: false,
    projectUrl: 'https://mimsha.com'
  }
];

const Projects: React.FC = () => {
  return (
    <section className="section projects-section" id="projects">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
          Demonstrating our expertise through impactful projects delivered by our team members during their professional journeys.
          </p>
          
          <div className="projects-grid">
            {projects.map((project, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="project-card"
                onClick={() => window.open(project.projectUrl, '_blank')}
              >
                <div className="project-image">
                  <div className={`wrapper ${project.iconPadding ? 'padding' : ''}`}><img src={project.image} /></div>
                </div>
                <div className="project-content">
                  <div className="project-header">
                    <h3 className="project-title">{project.title}</h3>
                    <span className="project-type">{project.type}</span>
                  </div>
                  <p className="project-description">{project.description}</p>
                  <div className="project-technologies">
                    {project.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects; 